import { Component } from '@angular/core';
import { CustomerDetailsService } from "./customerdetails.service";
import { CustomerDetailsType } from "./customerdetailstype";
import { ActivatedRoute } from '@angular/router';
import { DialogComponent } from '../dialog/dialog.component';
import { ConstantService } from "../providers/language.service";
import { Http, Response } from '@angular/http';
import { LanguageService } from '../providers/lang.service';
import { CookieService } from 'ngx-cookie-service';
import { CustomCookieService } from '../providers/mycookie.service';
import { DatePipe } from '@angular/common';
import { CustomStorage } from '../providers/Custom-storage.service';
import { SharedServiceService } from '../shared/shared-service.service';
import { CustomerdetailsData } from './customerdetailsData';
import { Constant } from '../Constant';
import { environment } from '../../environments/environment';
import { Router, NavigationStart } from '@angular/router';

@Component({
  selector: 'customer-details',
  templateUrl: './customerdetails.component.html',
  styleUrls: ['../app.component.css']
})

export class CustomerDetailsComponent {
  //  private imageUrl = environment.imageUrl + "{{item.pictures[0}}";
  // private imageUrl = "http://120.138.9.165:8810/CDIServices/{{item.pictures[0]}";
  customerdetailsData: any;
  selectedShippingAddress: any;  
  openOrder = [];
  public opened: boolean = false;
  public openedinvoice: boolean = false;
  custID: string;
  showDialog = false;
  showDialogopen = false;
  showDialoginovoice = false;
  showDialogorder = false;
  showDialogoverdue=false;
  private imageUrl = environment.imageUrl;
  totalsales: string = ""; availablecr: string = "";  salesin: string = "";
  openorder: string = ""; last_visit: string = "";  amount_inv: string = "";  amount_due: string = ""
  paymentinfo: string = "";  pricebook: string = "";  shippinginfo: string = "";  billinginfo: string = ""
  pay_term: string = "";  pay_method: string = "";  price_list: string = "";sales_inlast:string="";lbl_days:string="";
  account: string = "";  shop: string = ""; primary: string = "";  order: string = ""
  recentOrderDate: string = "";lbl_selected: string = "";lbl_dueon: string = "";lbl_invoicedate: string = "";
  date1: Date = null
  date2 = new Date()
  dateToDays: any = null
  invoice: string="";
  vieworder: String
  credit_limit: String
  cust_number: String
  view_invoice: String
  cust_type: String
  view_order: string = ""
  myjson: any;
  search_product: String;
  internet_check: String;
  open_status: String;
  public filteredList = [];
  public elementRef;
  public query = '';
  invoicenumber:String="0"
  private NextPhotoInterval: number = 3000;
  //Looping or not
  private noLoopSlides: boolean = false;
  //Photos
  private slides: Array<any> = [];
  public isOnline: boolean = navigator.onLine;
  items: Array<any> = []; 
  today: number = Date.now();
  constructor(public router: Router,private customerdetailService: CustomerDetailsService, route: ActivatedRoute, private http: Http,
    private languageservice: ConstantService, private langService: LanguageService, private cookieService: CustomCookieService, private localStorage : CustomStorage, private sharedService:SharedServiceService) {
  }

  ngOnInit() {
    this.sharedService.changeProductsSearchStatus(false);
    this.sharedService.changeBackbuttonStatus(false);
    this.sharedService.changeFooterSelected('account');

    this.langService.getJson().subscribe(data => {
      this.setLabels();  
      this.localStorage.getItem(Constant.KEY_CUSTOMER).subscribe(result => {
        this.customerdetailsData = result.response.data;
        this.sharedService.setDoNotAllowNegativeInvOrder(this.customerdetailsData.do_not_allow_negative_inv_order);
        this.sharedService.setAllowTopSellingItems(this.customerdetailsData.top_selling_item_active);
      this.sharedService.setAllowInspiredByPurchaseHistory(this.customerdetailsData.inspired_by_purchase_history_active);
        this.openOrder = this.customerdetailsData.open_order_info;   
        this.recentOrderDate = this.customerdetailsData.recent_order_date;
        

        this.lastLoginInDays();
        if (this.customerdetailsData.shipping_address.length > 0) {
          this.selectedShippingAddress = this.customerdetailsData.shipping_address[0]
        }
      });
    });
    // console.log(this);
  }

  invoicedescription(invoice_data) {
    this.localStorage.setItem('invoiceSelected', invoice_data).subscribe(res => {
      this.router.navigate(['/invoicedescription']);
    });
  }

  lastLoginInDays() {
    var date_diff_indays 
    this.date1 = new Date(this.recentOrderDate);
    var date2 = new Date();
    date_diff_indays = (Date.UTC(date2.getFullYear(), date2.getMonth(), date2.getDate()) - Date.UTC(this.date1.getFullYear(), this.date1.getMonth(), this.date1.getDate()) ) /(1000 * 60 * 60 * 24);

    this.dateToDays = Math.floor(date_diff_indays);

  }

   setLabels() {
    this.langService.getLangLabelValue("LblTotalSales").then(res => {
      this.totalsales =  res
    });
    //this.totalsales = await this.langService.getLangLabelValue("LblTotalSales");
    this.langService.getLangLabelValue("LblSalesin90Days").then(res => {
      this.salesin =  res
    });
    this.langService.getLangLabelValue("LblShippingInformation").then(res => {
      this.shippinginfo =  res
    });
    this.langService.getLangLabelValue("LblPriceBook").then(res => {
      this.pricebook  =  res
    });
    this.langService.getLangLabelValue("LblAmountInvoiced").then(res => {
      this.amount_inv  =  res
    });
    this.langService.getLangLabelValue("LblAmountOverdue").then(res => {
      this.amount_due =  res
    });
    this.langService.getLangLabelValue("LblAvailableCredit").then(res => {
      this.availablecr =  res
    });
    this.langService.getLangLabelValue("LblBillingInformation").then(res => {
      this.billinginfo =  res
    });
    this.langService.getLangLabelValue("LblCreditLimit").then(res => {
      this.credit_limit =  res
    });
    this.langService.getLangLabelValue("LblCustomerNumber").then(res => {
      this.cust_number =  res
    });

    this.langService.getLangLabelValue("LblViewOrder").then(res => {
      this.view_order =  res
    });
    this.langService.getLangLabelValue("LblViewInvoice").then(res => {
      this.view_invoice =  res
    });
    this.langService.getLangLabelValue("LblInvoice").then(res => {
      this.invoice =  res
    });

    this.langService.getLangLabelValue("LblPaymentInformation").then(res => {
      this.paymentinfo =  res
    });
    this.langService.getLangLabelValue("LblPriceBook").then(res => {
      this.pricebook =  res
    });
    this.langService.getLangLabelValue("LblPaymentMethod").then(res => {
      this.pay_method =  res
    });
    this.langService.getLangLabelValue("LblPriceList").then(res => {
      this.price_list =  res
    });
    this.langService.getLangLabelValue("LblPaymentTerm").then(res => {
      this.pay_term =  res
    });
    this.langService.getLangLabelValue("LblOpenOrder").then(res => {
      this.openorder =  res
    });
    this.langService.getLangLabelValue("LblType").then(res => {
      this.cust_type =  res
    });

    this.langService.getLangLabelValue("LblAccount").then(res => {
      this.account =  res
    });
    this.langService.getLangLabelValue("LblShop").then(res => {
      this.shop =  res
    });
    this.langService.getLangLabelValue("LblOrders").then(res => {
      this.order =  res
    });
    this.langService.getLangLabelValue("LblInvoice").then(res => {
      this.invoice =  res
    });
    this.langService.getLangLabelValue("LblOpen").then(res => {
      this.open_status =  res
    });
    this.langService.getLangLabelValue("LblProductSearch").then(res => {
      this.search_product =  res
    });
    this.langService.getLangLabelValue("LblInternetConnectivity").then(res => {
      this.internet_check =  res
    });
    this.langService.getLangLabelValue("LblInternetConnectivity").then(res => {
      this.internet_check =  res
    });
    this.langService.getLangLabelValue("LblXDaysSinceLastVisit").then(res => {
      this.last_visit =  res
    });
    this.langService.getLangLabelValue("LblPrimary").then(res => {
      this.primary =  res
    });
    this.langService.getLangLabelValue("LblSelected").then(res => {
      this.lbl_selected =  res
    });
    this.langService.getLangLabelValue("LblSalesInLast").then(res => {
      this.sales_inlast =  res
    });
    this.langService.getLangLabelValue("LblDays").then(res => {
      this.lbl_days =  res
    });
    this.langService.getLangLabelValue("LblDueOn").then(res => {
      this.lbl_dueon =  res
    });
    this.langService.getLangLabelValue("LblInvoiceDate").then(res => {
      this.lbl_invoicedate =  res
    });
  }
  setPrimaryAddress(selectedShippingAddress) {
    this.selectedShippingAddress = selectedShippingAddress;
  }

  // ngOnDestroy() {
  //   return this.sharedService.removeData();
  // }
  removeDataFromLS() {
    //return this.sharedService.removeData();
  }

  public close() {
    this.showDialog = false;
  }

  private removeLastSlide() {
    this.slides.pop();
  }

  public openInvoice() {
    this.openedinvoice = true;
  }

  

  select(item) {
    this.query = item;
    this.filteredList = [];
  }

  open(){
    
  }
}



// WEBPACK FOOTER //
// ./src/app/Customerdashboard/customerdetails.component.ts